export default class DrawTips {
  constructor({ className, draw }) {
    this._className = className;
    this._draw = draw;
  }

  onAdd(map) {
    // eslint-disable-next-line
    const me = this;
    const textNode = document.createTextNode("");
    const container = document.createElement("div");
    container.className = `mapboxgl-ctrl-group mapboxgl-ctrl ${
      this._className || ""
    }`;
    container.appendChild(textNode);
    container.style.display = "none";

    this._container = container;
    this._textNode = textNode;
    this._map = map;

    this._map.on("draw.modechange", e => {
      this.setMode(e.mode);
    });

    this._map.on("draw.delete", function (e) {
      const aois = me._draw.getAll();

      if (!aois || aois.features.length === 0) {
        me._textNode.textContent = "";
        me._container.style.display = "none";
      }
    });

    return this._container;
  }

  setMode(mode) {
    if (this._textNode) {
      if (mode === "draw_rectangle") {
        this._textNode.textContent =
          "To draw a rectangle click on the map to start and again to finish.";
        this._container.style.display = "block";
      } else if (mode === "draw_polygon") {
        this._textNode.textContent =
          "To draw a polygon click on the map to start.  Continue clicking to create vertices then double click to finish.";
        this._container.style.display = "block";
      } else {
        this._textNode.textContent = "";
        this._container.style.display = "none";
      }
    }
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._map.off("draw.modechange");
    this._map.off("draw.delete");
    this._map = undefined;
  }
}
